/** User-supplied SC-CAP-UX05 reading content. Never a formal capability mapping. */
export const capabilityEditorial = {
  schema: 'SC-CAP-UX05-editorial-v1',
  notice: '仅用于前台业务解释，不是正式能力定义、认证或真实装备状态',
  capabilities: [
    {
      key: 'CAP-SIGNAL',
      title: '监测线索汇总与核查辅助',
      domain: 'forest',
      image: '04_MEDIA/forest/F01-multisource-monitoring.webp',
      meaning:
        '把卫星热点、视频烟点、巡护报告等多种线索汇集到一张核查清单，而不是直接判定发生森林火灾。',
      problem: '报警和观测来源多、时间和坐标可能不同，容易重复或冲突。',
      outputs: '带来源与观测时间的线索列表；重复或冲突提示；待现场核实的位置。',
      method: '按来源分别保留时间、坐标与有效期，组织交叉比对，必要时交给人工核查。',
      limits: '卫星热点会误报或遗漏，视频存在遮挡，群众报告不等于已确认事实。',
      example: '多源监测控制台和火情线索核查流程（原创示意）',
      sourceIds: ['CN-MON-2024', 'NASA-FIRMS'],
      officialCapabilityId: null,
      certificationStatus: '未从权威系统确认',
      displayKind: '研究说明',
    },
    {
      key: 'CAP-AIR',
      title: '无人机空中巡查与观察',
      domain: 'forest',
      image: '04_MEDIA/forest/F02-drone-aerial-inspection.webp',
      meaning: '从空中补充道路、林冠、烟点和重点区域的可见光画面；按实际载荷也可获得热像资料。',
      problem: '地面或固定摄像机不易观察被遮挡的山脊与道路。',
      outputs: '带采集时间与位置的照片/视频、可观察区域记录，合适配置下的热像资料。',
      method: '按获批的巡查任务采集并归档影像，记录机型、载荷、航线、时间与来源。',
      limits:
        '受空域许可、天气、能见度、续航、林冠遮挡及实际载荷限制；工业无人机不自动等于火场适用。',
      example: '官方标准GB/T 47054—2026及DJI M30T规格（仅技术示例）',
      sourceIds: ['CN-UAV-2026', 'DJI-M30T'],
      officialCapabilityId: null,
      certificationStatus: '未从权威系统确认',
      displayKind: '研究说明',
    },
    {
      key: 'CAP-VIDEO',
      title: '固定视频与瞭望观察',
      domain: 'forest',
      image: '04_MEDIA/forest/F03-fixed-video-camera.webp',
      meaning: '在瞭望塔或林区监测点持续观察有限覆盖范围，帮助比对烟点出现时间和方向。',
      problem: '广域范围内持续值守较难、人工巡查存在时间空档。',
      outputs: '监控画面、录制时间、摄像机方向与覆盖区域；可疑线索等待复核。',
      method: '固定可见光摄像机、可选热成像设备与传输网络共同形成监控记录。',
      limits: '摄像机并非全覆盖；逆光、天气、植被遮挡及断网可能影响观察；算法告警不直接证明起火。',
      example: '森林草原防火视频监控系统技术规范（技术架构）',
      sourceIds: ['CN-VIDEO-2026', 'CN-MON-2024'],
      officialCapabilityId: null,
      certificationStatus: '未从权威系统确认',
      displayKind: '研究说明',
    },
    {
      key: 'CAP-COMMS',
      title: '林区通信与信息回传',
      domain: 'forest',
      image: '04_MEDIA/forest/F07-emergency-relay-network.webp',
      meaning: '把巡护人员、临时观察点与后方之间的语音、照片和位置线索传出去，并记录联络是否成功。',
      problem: '山区、林区网络盲区和断电会妨碍线索核实与人员联系。',
      outputs: '语音或图像回传记录、联络对象、传输时刻、测通情况。',
      method: '结合已有公网、专网、对讲、卫星与临时链路，按已核实条件选择合适通路。',
      limits: '设备存在不等于连通；需要验证覆盖、电源、频率许可、链路质量和时延。',
      example: '海能达应急通信组网图文与官方演示视频入口',
      sourceIds: ['HYTERA', 'CN-AUDIOVIDEO'],
      officialCapabilityId: null,
      certificationStatus: '未从权威系统确认',
      displayKind: '研究说明',
    },
    {
      key: 'CAP-METEO',
      title: '气象与环境信息获取',
      domain: 'forest',
      image: '04_MEDIA/forest/F05-weather-monitoring-station.webp',
      meaning: '采集或引用火情附近的风向风速、温湿度、降水等资料，帮助理解当时的环境条件。',
      problem: '远处气象站或单次预报不能完整反映山谷局部变化。',
      outputs: '带站点、时间、测量单位的观测记录；官方预报；数据时间差提示。',
      method: '使用已接入气象站、气象部门公开数据、历史变化曲线，对比来源与时效。',
      limits: '站点代表性有限，预报不等于实测，单个数值不能自动判定火势变化或火险等级。',
      example: '林区自动气象站及多源预警监测要求',
      sourceIds: ['CN-MON-2024'],
      officialCapabilityId: null,
      certificationStatus: '未从权威系统确认',
      displayKind: '研究说明',
    },
    {
      key: 'CAP-MULTISOURCE',
      title: '多时相观测与变化对照',
      domain: 'forest',
      image: '04_MEDIA/forest/F04-satellite-hotspot-analysis.webp',
      meaning:
        '将不同时点的卫星、无人机和视频资料放在一致坐标及时间轴上，识别可供进一步核查的变化。',
      problem: '不同资料分辨率、拍摄角度、时间不同，容易误把画面差异当作火线变化。',
      outputs: '有来源的前后图像对照、时间轴和待解释变化点。',
      method: '记录数据分辨率、时间、坐标基准并进行人工校核后的对比。',
      limits: '不能从简单图像变化直接计算精确火线或安全的扩散预测；热点不代表整个像元起火。',
      example: 'NASA FIRMS热点资料与监测误差说明',
      sourceIds: ['NASA-FIRMS', 'CN-MON-2024'],
      officialCapabilityId: null,
      certificationStatus: '未从权威系统确认',
      displayKind: '研究说明',
    },
    {
      key: 'CAP-GEO',
      title: '地形与道路资料查看',
      domain: 'forest',
      image: '04_MEDIA/forest/F06-terrain-gis-mapping.webp',
      meaning:
        '把山脊、沟谷、林区道路、河流、居民点等放在同一空间视图，辅助判断需要进一步核对哪里。',
      problem: '山地道路和地形复杂，仅靠文字描述难以定位相关对象。',
      outputs: '位置关系图、通路候选、地图时效信息、待核实区域清单。',
      method: '复用已有GIS、地形图和遥感底图，叠加已核对的道路与重点对象记录。',
      limits: '地图上有道路不代表可通行；桥梁、塌方、封闭和障碍必须另行核实。',
      example: '森林防火信息系统数据字典与地理资料结构',
      sourceIds: ['CN-SYSTEM-2025'],
      officialCapabilityId: null,
      certificationStatus: '未从权威系统确认',
      displayKind: '研究说明',
    },
    {
      key: 'CAP-PERSON',
      title: '人员联络与位置线索核实',
      domain: 'forest',
      image: '04_MEDIA/forest/F08-personnel-coordination.webp',
      meaning: '整理巡护队员、游客和居民的联系记录，区分本人确认、第三方报告和仍然未知的情况。',
      problem: '人员状态分散在不同通话或报送中，位置线索可能过期。',
      outputs: '联络对象清单、最后确认时间、报告来源、待联系事项。',
      method: '通过获准的对讲、电话、消息和人工核实记录进行状态整理。',
      limits: '无联系不等于受困，位置共享需要授权和隐私保护；不自动生成撤离命令。',
      example: '消防应急通信实践与人员信息整理',
      sourceIds: ['CN-AUDIOVIDEO', 'CN-FOREST-2026'],
      officialCapabilityId: null,
      certificationStatus: '未从权威系统确认',
      displayKind: '研究说明',
    },
    {
      key: 'CAP-RELAY',
      title: '临时通信中继与补盲',
      domain: 'forest',
      image: '04_MEDIA/forest/F07-emergency-relay-network.webp',
      meaning: '在现有网络不足时，通过现场中继、便携基站或卫星链路研究补充联系通路。',
      problem: '山脊或峡谷遮挡导致地面人员与后方失联。',
      outputs: '已测试的可达区域、联络与图传测试记录、链路替代方案。',
      method: '由通信人员选择适当设备，测试覆盖、电源、频率及网络接入条件。',
      limits: '中继不等于全面覆盖；本地无线电使用许可、地形与电池条件均需确认。',
      example: '海能达应急组网与消防通信保障训练',
      sourceIds: ['HYTERA', 'CN-AUDIOVIDEO'],
      officialCapabilityId: null,
      certificationStatus: '未从权威系统确认',
      displayKind: '研究说明',
    },
    {
      key: 'CAP-PATROL',
      title: '日常巡护与火源风险记录',
      domain: 'forest',
      image: '04_MEDIA/forest/F09-ground-fire-patrol.webp',
      meaning: '长期登记重点路段、进山入口、火源活动及巡护发现的问题，形成可复查的风险线索。',
      problem: '防火多在事故前发生，需要知道重点区域哪些地方已经看过、哪些仍未核实。',
      outputs: '巡护轨迹、检查点、发现时间、照片、处理状态与复查记录。',
      method: '由人员使用已有巡护终端/台账进行带来源的记录与复查。',
      limits: '记录有缺漏或误报；不能根据图片自动认定违法用火或形成执法结论。',
      example: '森林草原防灭火条例与火情源头公开案例',
      sourceIds: ['CN-FOREST-2026', 'CN-ANHUI-CASES'],
      officialCapabilityId: null,
      certificationStatus: '未从权威系统确认',
      displayKind: '研究说明',
    },
    {
      key: 'HR-SMOKE',
      title: '烟气控制与通风支持',
      domain: 'highrise',
      image: '04_MEDIA/highrise/H01-smoke-ventilation-fan.webp',
      meaning:
        '通过建筑原有防烟排烟设施或合适的便携通风设备，为烟气控制提供物理作用和相关状态信息。',
      problem: '高层建筑竖向空间可能使烟气扩散；需要区分观察烟气与改变气流这两种工作。',
      outputs: '系统运行状态、设备工作状态、合适条件下的通风效果观察记录。',
      method: '有经维护核验的建筑系统、便携风机或专用机器人风机模块；由专业人员决定是否适用。',
      limits: '通风方式与开口、分隔、烟气条件密切相关；不凭设备存在自动建议启停或人员进入。',
      example: 'LEADER BATFAN 3 Li+ 官方产品页',
      sourceIds: ['LEADER-FAN', 'CN-HIGHRISE-2021'],
      officialCapabilityId: null,
      certificationStatus: '未从权威系统确认',
      displayKind: '研究说明',
    },
    {
      key: 'HR-THERMAL',
      title: '高处与热成像观察',
      domain: 'highrise',
      image: '04_MEDIA/highrise/H02-handheld-thermal-imager.webp',
      meaning: '用可见光或热成像方式观察可视范围内的温度分布及疑似异常位置，形成进一步核实的线索。',
      problem: '高处、浓烟和远距离情况不易通过肉眼持续观察。',
      outputs: '带拍摄角度/时间的外部画面、热分布图和需要核查的疑似异常区域。',
      method: '适配消防热像仪，或有热成像载荷的无人机在获准条件下采集。',
      limits: '热像不等于穿墙观察，测得的是可见表面热信息；视频不自动证明内部结构和人员状况。',
      example: 'DJI M30T 官方热像规格、FLIR热像局限说明',
      sourceIds: ['DJI-M30T', 'FLIR-LIMIT', 'CN-DRILL-2026'],
      officialCapabilityId: null,
      certificationStatus: '未从权威系统确认',
      displayKind: '研究说明',
    },
    {
      key: 'HR-INDOOR',
      title: '室内空间检查',
      domain: 'highrise',
      image: '04_MEDIA/highrise/H03-indoor-inspection-drone.webp',
      meaning: '在适用且经允许的空间用遥控设备获取障碍、连通、可视区域和结构表面信息。',
      problem: '人员不宜首先进入的封闭、昏暗或障碍空间缺少可靠观察资料。',
      outputs: '带时间的室内视频、局部点云或三维空间记录（以实际设备配置为准）。',
      method: '专业遥控检查设备、带防撞结构的无人机或移动检查机器人等。',
      limits: '工业检查设备不自动具备高温火场认证；烟气、热、定位与通信会限制应用。',
      example: 'Flyability Elios 3 官方室内检查与建图介绍',
      sourceIds: ['FLY-ELIOS', 'NIST-ROBOTS'],
      officialCapabilityId: null,
      certificationStatus: '未从权威系统确认',
      displayKind: '研究说明',
    },
    {
      key: 'HR-COMMS',
      title: '现场通信与信息回传',
      domain: 'highrise',
      image: '04_MEDIA/highrise/H06-field-communications.webp',
      meaning: '在建筑内外、现场与后方之间提供合适的语音、图像和位置回传通路。',
      problem: '楼层、钢筋混凝土及通信障碍可能导致信息无法及时返回。',
      outputs: '通联对象和链路状态、语音/图像回传、失败位置与重试记录。',
      method: '使用合规对讲、已有建筑通信设施、便携中继和图像回传手段。',
      limits: '不能用一次测通保证全楼覆盖；视频带宽、续航、供电和频率需核查。',
      example: '消防救援通信保障与应急音视频技术要求',
      sourceIds: ['CN-AUDIOVIDEO', 'HYTERA'],
      officialCapabilityId: null,
      certificationStatus: '未从权威系统确认',
      displayKind: '研究说明',
    },
    {
      key: 'HR-SEARCH',
      title: '人员线索搜寻',
      domain: 'highrise',
      image: '04_MEDIA/highrise/H02-handheld-thermal-imager.webp',
      meaning: '在合适条件下结合热像、音视频与人工报告寻找需要进一步核实的人员线索。',
      problem: '火场浓烟、隔断、黑暗导致直接识别人员的难度增大。',
      outputs: '疑似人员位置线索、来源与时间、待进一步确认的信息。',
      method: '专业人员结合适用的热像观察、人工搜索和通信记录综合研判。',
      limits: '热像可能误判，隔墙不可穿透；线索不等于已找到或确认安全人员。',
      example: '消防热像仪官方规格与消防高层演练资料',
      sourceIds: ['FLIR-LIMIT', 'CN-DRILL-2026'],
      officialCapabilityId: null,
      certificationStatus: '未从权威系统确认',
      displayKind: '研究说明',
    },
    {
      key: 'HR-SPACE',
      title: '空间与路径信息获取',
      domain: 'highrise',
      image: '04_MEDIA/highrise/H03-indoor-inspection-drone.webp',
      meaning: '整理楼层、通道、楼梯间和局部障碍之间的空间关系，帮助了解需要核对的区域。',
      problem: '已有图纸可能缺少改造情况，现场通道状况又会变化。',
      outputs: '局部空间影像、点云/三维参考和待核实的障碍位置。',
      method: '结合建筑资料、人工核查和获准的室内检查设备。',
      limits: '点云或模型不能自动证明安全路线可通行；仍需现场核实。',
      example: 'Elios 3 室内检查与空间数据获取示例',
      sourceIds: ['FLY-ELIOS', 'CN-HIGHRISE-2021'],
      officialCapabilityId: null,
      certificationStatus: '未从权威系统确认',
      displayKind: '研究说明',
    },
    {
      key: 'HR-REMOTE',
      title: '远程灭火等物理处置支持',
      domain: 'highrise',
      image: '04_MEDIA/highrise/H04-ground-suppression-robot.webp',
      meaning: '在满足设备和现场条件时，通过遥控平台在一定距离外承担特定物理操作。',
      problem: '高温或未知危险环境中减少人员直接暴露的需求。',
      outputs: '具体动作的执行反馈、设备状态和必要的远程观察画面。',
      method: '采用与任务匹配的灭火机器人及对应水炮、观察或运输模块，专业人员授权后操作。',
      limits: '本页面不指定战术或调度；现场地形、供水、通信和配置须独立核验。',
      example: 'Shark Robotics Colossus模块及NIST机器人测试方法',
      sourceIds: ['SHARK-COLOSSUS', 'NIST-ROBOTS'],
      officialCapabilityId: null,
      certificationStatus: '未从权威系统确认',
      displayKind: '研究说明',
    },
    {
      key: 'HR-PLANS',
      title: '建筑资料与消防设施核对',
      domain: 'highrise',
      image: '04_MEDIA/highrise/H09-building-plans-check.webp',
      meaning: '帮助查看建筑平面图、楼层功能、消防设施分布与管理资料，形成场景所需的信息清单。',
      problem: '事故发生时单靠现场口述难以掌握竖向井道、分隔及设施分布。',
      outputs: '建筑图纸索引、消防设施记录、来源日期以及待现场核实的差异清单。',
      method: '查阅经许可的建筑资料、消防控制室保存的图纸及管理记录。',
      limits: '图纸可能过时；不能据此证明某栋建筑当前设备可用或通道畅通。',
      example: '高层民用建筑消防安全管理规定（图纸与设施资料）',
      sourceIds: ['CN-HIGHRISE-2021'],
      officialCapabilityId: null,
      certificationStatus: '未从权威系统确认',
      displayKind: '研究说明',
    },
    {
      key: 'HR-MOVEMENT',
      title: '建筑结构位移监测',
      domain: 'highrise',
      image: '04_MEDIA/highrise/H07-structure-movement-monitoring.webp',
      meaning: '用合适的位移测量设备持续观察某一可见结构目标是否出现位移变化。',
      problem: '高处坠物或受损构件可能存在动态变化，需要可重复的客观测量线索。',
      outputs: '带测点位置、测量方向、时间的位移变化与设备告警记录。',
      method: '使用经校核的测距/位移监测设备，由人员设定测点和阈值。',
      limits: '位移传感器不是建筑整体安全鉴定；单一方向监测不能覆盖全部失稳风险。',
      example: 'LEADER SENTRY B2 结构监测设备',
      sourceIds: ['LEADER-SENTRY'],
      officialCapabilityId: null,
      certificationStatus: '未从权威系统确认',
      displayKind: '研究说明',
    },
    {
      key: 'HR-TRANSFER',
      title: '人员转运与协同辅助',
      domain: 'highrise',
      image: '04_MEDIA/highrise/H08-rescue-stretcher-assistance.webp',
      meaning: '在真实任务经授权后，为人员转移、担架转运和队伍协同提供装备与信息支持。',
      problem: '人员移动可能受楼梯、障碍和通道条件限制。',
      outputs: '所需器材与人员协同信息、通路限制记录、转运过程反馈。',
      method: '专业救援队和符合条件的运输/担架辅助设备；部分机器人存在专用担架模块。',
      limits: '不得把设备模型等同于自动搬运能力；不据研究页制定具体转移路线。',
      example: 'Colossus官方担架支架模块参考',
      sourceIds: ['SHARK-COLOSSUS'],
      officialCapabilityId: null,
      certificationStatus: '未从权威系统确认',
      displayKind: '研究说明',
    },
    {
      key: 'HR-GAS',
      title: '环境气体检测（技术参考）',
      domain: 'highrise',
      image: '04_MEDIA/highrise/H05-gas-monitoring-device.webp',
      meaning: '依照配置的传感器检测某些气体或氧含量，辅助了解有限位置的环境指标。',
      problem: '未知环境中仅靠热像无法判断气体成分或氧含量。',
      outputs: '与特定传感器对应的气体浓度读数、告警和采集位置时间。',
      method: '使用经过校准、配置正确且有对应操作人员的便携式多气体检测仪。',
      limits: '传感器种类与量程因配置而异；一处读数不能代表整个建筑或认定安全。',
      example: 'Dräger X-am 8000 实际可选传感器与测量条件',
      sourceIds: ['DRAEGER-XAM'],
      officialCapabilityId: null,
      certificationStatus: '未从权威系统确认',
      displayKind: '研究说明',
    },
  ],
} as const;
